import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "12.41 6.75 13 2 10.57 4.92", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "18.57 12.91 21 10 15.66 10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "8 8 3 14 12 14 11 22 16 16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ZapOff";
const ZapOff = memo(themed(Icon));
export {
  ZapOff
};
//# sourceMappingURL=zap-off.js.map
